import React from "react";
import { SearchModal } from "../modals/SearchModal";
import { MODAL_TYPES, ModalType } from "../../constants";
import { SearchResults } from "../../models";

interface SearchModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  searchCriteria: {
    locations: string[];
    heats: string[];
    sections: string[];
    lengths: string[];
    grades: string[];
    qualities: string[];
    destinations: string[];
  };
  onClose: () => void;
  onSearchResults: (results: SearchResults | null) => void;
  onCriteriaUpdate: (criteria: {
    locations: string[];
    heats: string[];
    sections: string[];
    lengths: string[];
    grades: string[];
    qualities: string[];
    destinations: string[];
  }) => void;
}

export const SearchModalWrapper = ({
  currentModal,
  isModalOpen,
  searchCriteria,
  onClose,
  onSearchResults,
  onCriteriaUpdate,
}: SearchModalWrapperProps) => {
  if (!isModalOpen(MODAL_TYPES.SEARCH)) {
    return null;
  }

  return (
    <SearchModal
      open={currentModal === MODAL_TYPES.SEARCH}
      onClose={onClose}
      onSearchResults={onSearchResults}
      initialCriteria={searchCriteria}
      onCriteriaUpdate={onCriteriaUpdate}
    />
  );
};
